import React, {useState, useEffect} from 'react';
import {createRoot} from 'react-dom/client';
import OpenMenuIcon from '../../../svg/icon-menu-open.svg';
import CloseMenuIcon from '../../../svg/icon-menu-close.svg';
import SiteLogo from '../../../svg/site-logo.svg';
import ArrowRight from '../../../svg/arrow-right.svg';
// import Owl from '../../../svg/owl-woops.svg';
import Owl from '../../../svg/owl.svg';
// import Owl from '../../../images/owl.png';

const HamburgerMenu = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    // メニュー開閉トグル処理
    const toggleMenu = () => setMenuOpen(prevState => !prevState);

    // アンカーリンク
    const handleLinkClick = (event, targetId) => {
        event.preventDefault(); // デフォルトのアンカーリンクの動作を防ぐ
        setMenuOpen(false); // メニューを閉じる

        // targetId の存在チェック
        if (!targetId) {
            console.error('Invalid targetId provided');
            return;
        }

        const targetElement = document.getElementById(targetId);
        if (!targetElement) {
            console.error(`Element with ID "${targetId}" not found`);
        }

        // 現在のURLやウィンドウ位置がトップページか確認
        if (window.location.pathname === '/') {
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                // ターゲット要素へスムーズスクロール
                targetElement.scrollIntoView({behavior: 'smooth'});
            }
        } else {
            // 子ページの場合、トップページに遷移
            window.location.href = `https://gakkocho.jp#${targetId}`;
        }

        // ヘッダーの高さを取得
        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 64; // デフォルト値を設定 (64px)

        // オフセット値
        const additionalOffset = 16; // 固定値または調整可能設定
        const offset = headerHeight + additionalOffset;

        // スクロール先の位置を計算
        const targetPosition =
            targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

        // スクロール処理の互換性対応
        if ('scrollBehavior' in document.documentElement.style) {
            // モダンブラウザ用のスムーズスクロール
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth',
            });
        } else {
            // 古いブラウザ用のフォールバック
            window.scrollTo(0, targetPosition);
        }
    };


    // メニュー状態に応じてスクロールを無効化
    useEffect(() => {
        if (menuOpen) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }

        return () => {
            document.body.classList.remove('no-scroll'); // クリーンアップ
        };
    }, [menuOpen]);

    // Escapeキーでメニューを閉じるリスナーの登録
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') setMenuOpen(false);
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    // クラス名の動的切り替え
    const menuClassName = menuOpen ? 'menu-items open' : 'menu-items';

    return (
        <div className="hamburger-menu-container">
            {/* ハンバーガーメニュー */}
            <div className="hamburger-menu" onClick={toggleMenu}>
                <div className="hamburger-icon">
                    <img className="icon-arrow" src={OpenMenuIcon} alt=""/>
                </div>
            </div>

            {/* 出現メニュー */}
            <nav className={menuClassName}>

                <div className={"hamburger-menu--header"}>
                    <div className="hamburger-menu padding-left-28"
                         onClick={toggleMenu}>
                        <div className="hamburger-icon hamburger-icon--menu">
                            <img src={CloseMenuIcon} alt=""/>
                        </div>
                    </div>
                    <div className="site-logo site-logo--sp">
                        <a className="site-logo__link" href={"/"}>
                            <img src={SiteLogo} alt=""/>
                        </a>
                    </div>
                    <div className="date-container transparent">
                        <div
                            className="date-month-day">
                            00.00
                        </div>
                        <div className="date-weekday">EEE
                        </div>
                        <div className="date-year"></div>
                    </div>
                    <hr className={"cp_hr12 under-line"}/>
                </div>
                <div className={"mobile-menu__container"}>
                    <div className="mobile-menu__contents">
                        <h2 className="mobile-menu__heading">
                            About this Website
                        </h2>
                        <p className="mobile-menu__text">
                            本サイト、学校町の連絡帳<br/>
                            略して「ガッコウチョウ」では<br/>
                            新潟市中央区<br/>
                            学校町エリア周辺での出来事や<br/>
                            イベント情報を<br/>
                            お知らせしていきます
                        </p>
                        {/*  フクロウ  */}
                        <div className="owl">
                            <img className={"icon-owl"} src={Owl} alt=""/>
                        </div>
                    </div>
                    <div className="mobile-menu__links">
                        <ul>
                            <li>
                                <div className="mobile-menu__links-item">
                                    <a className={"gap-025em"} href="#item1">
                                        <span>SNS</span>
                                        <img className={"icon-arrow"}
                                             src={ArrowRight} alt=""/>
                                    </a>
                                </div>

                                <div className="sns-menu">
                                    <div className={"sns-menu__item"}>
                                        <span
                                            className={"sns-menu__title"}>現代市</span>
                                        <a href="https://www.instagram.com/niigata_imaichi?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                           target="_blank">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16" height="16"
                                                fill="currentColor"
                                                className="bi bi-instagram"
                                                viewBox="0 0 16 16">
                                                <path
                                                    d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
                                            </svg>
                                        </a>
                                        {/*<a href="#" target="_blank">*/}
                                        {/*    <svg*/}
                                        {/*        xmlns="http://www.w3.org/2000/svg"*/}
                                        {/*        width="16" height="16"*/}
                                        {/*        fill="currentColor"*/}
                                        {/*        className="bi bi-twitter-x"*/}
                                        {/*        viewBox="0 0 16 16">*/}
                                        {/*        <path*/}
                                        {/*            d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>*/}
                                        {/*    </svg>*/}
                                        {/*</a>*/}
                                    </div>
                                    <div className={"sns-menu__item"}>
                                        <span
                                            className={"sns-menu__title"}>学校町マルシェ</span>
                                        <a href="https://www.instagram.com/gakkoucho.marche?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                           target="_blank">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16" height="16"
                                                fill="currentColor"
                                                className="bi bi-instagram"
                                                viewBox="0 0 16 16">
                                                <path
                                                    d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
                                            </svg>
                                        </a>
                                        <a href="https://x.com/gakkoucho"
                                           target="_blank">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16" height="16"
                                                fill="currentColor"
                                                className="bi bi-twitter-x"
                                                viewBox="0 0 16 16">
                                                <path
                                                    d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="mobile-menu__links-item">
                                    <a href={`https://gakkocho.jp#news`}
                                       onClick={(event) => handleLinkClick(event, 'news')}>
                                        <span>What's New</span>
                                        <img className={"icon-arrow"}
                                             src={ArrowRight} alt=""/>

                                    </a>
                                </div>
                            </li>
                            <li>
                                <div className="mobile-menu__links-item">
                                    <a href={`https://gakkocho.jp#event`}
                                       onClick={(event) => handleLinkClick(event, 'event')}>
                                        <span>Event</span>
                                        <img className={"icon-arrow"}
                                             src={ArrowRight} alt=""/>
                                    </a>
                                </div>
                            </li>
                            {/*<li>*/}
                            {/*    <div className="mobile-menu__links-item">*/}
                            {/*        <a href="#item1" onClick={handleLinkClick}>*/}
                            {/*            <span>Store</span>*/}
                            {/*            <img className={"icon-arrow"}*/}
                            {/*                 src={ArrowRight} alt=""/>*/}
                            {/*        </a>*/}
                            {/*    </div>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*    <div className="mobile-menu__links-item">*/}
                            {/*        <a href="#item1" onClick={handleLinkClick}>*/}
                            {/*            <span>Area</span>*/}
                            {/*            <img className={"icon-arrow"}*/}
                            {/*                 src={ArrowRight} alt=""/>*/}
                            {/*        </a>*/}
                            {/*    </div>*/}
                            {/*</li>*/}
                        </ul>
                    </div>
                </div>
            </nav>

            {/* オーバーレイ */}
            {menuOpen && <div className="menu-overlay"
                              onClick={() => setMenuOpen(false)}></div>}
        </div>
    );
};

// DOMへのマウント
document.addEventListener('DOMContentLoaded', () => {
    const hamburgerContainers = document.querySelectorAll('.hamburger-menu-container');
    hamburgerContainers.forEach((container) => {
        const root = createRoot(container);
        root.render(<HamburgerMenu/>);
    });
});


const ScrollToAnchor = () => {
    useEffect(() => {
        // URLにアンカーが含まれる場合
        const anchorId = window.location.hash.substring(1); // "#"以降の文字列を取得
        if (anchorId) {
            const targetElement = document.getElementById(anchorId);
            if (targetElement) {
                targetElement.scrollIntoView({behavior: 'smooth'});
            }
        }
    }, []); // 初回レンダー時のみ実行

    return null;
};

export default ScrollToAnchor;
